<template>
  <div class="paddinglr0">
    <el-collapse v-model="activeNames">
      <!--      <el-collapse-item name="1">-->
      <!--        <template slot="title">-->
      <!--          <div class="tabs flex">-->
      <!--            &lt;!&ndash;            <div :class="tabsActive == 0 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 0)">&ndash;&gt;-->
      <!--            &lt;!&ndash;              推荐&ndash;&gt;-->
      <!--            &lt;!&ndash;            </div>&ndash;&gt;-->
      <!--            <div :class="tabsActive == 1 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 1)">-->
      <!--              我的-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </template>-->
      <div class="setting-item">
        <!--          <template v-if="tabsActive === 0">系统模板</template>-->
        <template v-if="tabsActive === 1">
          <div class="empty-style" v-if="myModules.length === 0">
            <p>暂无内容</p>
          </div>
          <ul class="module-lists" v-else>
            <li v-for="(module, index) in myModules" class="module-list" @click="selectStageModule(module)">
              <div class="module-list-cover">
                <div class="icon-groups">
                  <span class="icon icon-portal-delete" @click.stop="delMyModule(module)"></span>
                </div>
              </div>
              <div>{{ module.title }}</div>
            </li>
          </ul>
        </template>
      </div>
      <!--      </el-collapse-item>-->
    </el-collapse>
  </div>
</template>

<script>
import instance from "../../../interceptor"
import { initStageModules } from "../../../utils/initEv"
import { decrypt } from "utils"
import { reverseBuildModel } from "utils/reverseBuildModel"
import { data_dictionary_map } from "../../../../static/dataDictionary.js"
import { queryComponentContent } from "api/module"

export default {
  name: "container-style",
  data() {
    return {
      activeNames: ["1"],
      tabsActive: 1
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    myModules() {
      return this.$store.state.menu.myModules || []
    }
  },
  mounted() {
    if (this.myModules.length === 0) {
      initStageModules.call(this)
    }
  },
  methods: {
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    delMyModule(module) {
      const self = this
      if (module.encId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
              .post(`v2/${module.encId}/remove`)
              .then(() => {
                initStageModules.call(self)
              })
              .catch(err => {})
          })
          .catch(() => {
            // this.$message({ customClass: "bigScreen_msg_backGroud", duration: 3000, type: "info", message: "取消删除" })
          })
      }
    },
    selectStageModule(module) {
      this.$confirm("页面模板会覆盖编辑区已有组件，是否继续？", "", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          this.$API
            .queryComponentContent({
              encId: module.encId
            })
            .then(res => {
              let data = res.data.data
              if (data !== undefined && data.content && data.content.length > 30) {
                //还原被encryption方法加密过json字符串
                data.content = decrypt(data.content, data_dictionary_map)
                //将json中的rem转为px
                reverseBuildModel(data.content)
              }
              let content = JSON.parse(JSON.stringify(data.content))
              content.container_id = this.ids.container_id
              content.isActive = true
              this.$store.dispatch(this.request_prefix + "/changeContainerData", content)
            })
        })
        .catch(() => {
          this.$message({ customClass: "bigScreen_msg_backGroud", duration: 3000, type: "info", message: "已取消" })
        })
    }
  }
}
</script>

<style scoped lang="scss">
.paddinglr0 {
  padding: 0 !important;
}
.module-lists {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  box-sizing: border-box;
}
.module-list {
  text-align: center;
  color: var(--text);
  width: 120px;
  margin-bottom: 16px;
  cursor: pointer;
  .module-list-cover {
    position: relative;
    width: 118px;
    height: 189px;
    border-radius: 2px;
    border: 2px solid var(--borderColorFour);
    .icon-groups {
      position: absolute;
      display: none;
      top: 8px;
      right: 8px;
    }
    .icon {
      display: inline-block;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 3px;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      color: #fff;
    }
  }
  &:hover {
    .module-list-cover {
      border: 2px solid var(--themeColorDisabled);
      .icon-groups {
        display: inline-block;
      }
    }
  }
}
.empty-style {
  // padding-top: 280px;
  padding: 20px 0;
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: var(--thirdTextColor);
    text-align: center;
  }
}
</style>
